module.exports = __webpack_public_path__ + "static/media/imgll3.675b61f9.jpg";